export const THEME_LOCALSTORAGE_KEY = 'theme';
export const LANGUAGE_LOCALSTORAGE_KEY = 'i18nextLng';
export const SYMBOL_LOCALSTORAGE_KEY = 'symbol';
export const INTERVAL_LOCALSTORAGE_KEY = 'interval';
export const TRADING_JOURNAL_DISCLAMER_CLOSED_KEY =
    'trading_journal_disclamer_closed';
export const REFERRAL_CODE_LOCALSTORAGE_KEY = 'algotech_ref';
